export const meta: BlockMeta = {
  title: "Divider",
  description: "A content divider",
  category: "layouts",
  icon: "book-alt",
  keywords: ["post"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame", "resource"],
  },
  tags: ["root"],
}

import { Divider } from "@components/atoms/Divider"
import { defineBlock } from "eddev/blocks"

export default defineBlock("content/divider", (props) => {
  return <Divider size={props.size || "medium"} />
})
